import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { OrganisationsService, UserService } from '../../services';
import { SelectItem } from 'primeng';

@Component({
  selector: 'app-impersonate-organisation',
  templateUrl: './impersonate-organisation.component.html',
})
export class ImpersonateOrganisationComponent implements OnChanges {
  @Input() organisationId: number | null = null;
  @Input() showDialog = false;
  @Output() onClose = new EventEmitter<void>();

  users: SelectItem[] = [];
  selectedUser: any;
  loading = false;

  private currentOrganisationId: number | null = null;

  constructor(private orgService: OrganisationsService, private userService: UserService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.organisationId &&
      changes.organisationId.currentValue !== this.currentOrganisationId
    ) {
      this.currentOrganisationId = changes.organisationId.currentValue;
      void this.loadUsersForOrganisation(this.currentOrganisationId);
    }

    if (changes.showDialog && !!changes.showDialog.currentValue) {
      if (this.users?.length == 1) {
        this.closeDialog();
        this.impersonateUser(this.users[0].value);
        return;
      }
    }
  }

  async loadUsersForOrganisation(organisationId: number | null): Promise<void> {
    if (!organisationId) return;

    this.loading = true;
    let users = await this.orgService.getImpersonationUsersList(organisationId);

    this.users = users.map((user) => {
      return { label: user.name || user.email, value: user.id };
    });

    this.loading = false;
  }

  closeDialog(): void {
    this.showDialog = false;
    this.onClose.emit();
  }

  confirmImpersonation(): void {
    if (this.selectedUser) {
      this.showDialog = false;
      this.onClose.emit();
      this.impersonateUser(this.selectedUser);
    }
  }

  impersonateUser(userId) {
    const obj = {
      ImpersonatedUserGUID: userId,
      ImpersonatedUserName: '',
      OriginalUserName: '',
      IsImpersonating: false,
    };
    this.userService.impersonateUser(obj).then((res) => {
      window.location.reload();
      window.location.href = '/';
    });
  }
}
